import Permissions from '@/app/permissions/Permissions';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';

const HISTORICS_TABS = {
    SIM_CARDS:
    {
        name: 'sim_cards_historics',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.LIST_HISTORY.name] })
    },
    POS_TERMINALS:
    {
        name: 'pos_terminals_historics',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.LIST_HISTORY.name] })
    },
    USERS:
    {
        name: 'users_historics',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.LIST_HISTORY.name] })
    }
};

HISTORICS_TABS.DEFAULT = HISTORICS_TABS.POS_TERMINALS;

export default HISTORICS_TABS;